// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Xdg5poXFubocHfy_O6DR {\n  max-height: 30rem;\n  max-width: 30rem;\n}\n\n._P8pGS_wK_jkS6WcohM1 a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n", "",{"version":3,"sources":["webpack://./src/components/lower/article.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".articleImage {\n  max-height: 30rem;\n  max-width: 30rem;\n}\n\n.container a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleImage": "Xdg5poXFubocHfy_O6DR",
	"container": "_P8pGS_wK_jkS6WcohM1"
};
export default ___CSS_LOADER_EXPORT___;
